import { createTheme } from '@mui/material';

import { palette } from './config';

export const theme = createTheme({
  palette,
  colorSchemes: {
    dark: true,
  },
});
